export interface LoadingBadgeProps {
  expectedChars: number;
  className: string;
}

export const LoadingBadge = (props: LoadingBadgeProps) => {
  return (
    <>
      <span
        className={`${props.className} rounded-md bg-gray-300 
        animate-pulse hide-text px-2 py-1 ring-1 ring-inset ring-gray-50`}
      >
        {'x'.repeat(props.expectedChars)}
      </span>
    </>
  );
};
